module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M10 0C8.894 0 8 .894 8 2v24c0 1.1-.9 2-2 2s-2-.9-2-2V5a1 1 0 0 0-1-1H2C.894 4 0 4.894 0 6v20c0 3.32 2.68 6 6 6h20c3.32 0 6-2.68 6-6V2c0-1.106-.894-2-2-2H10zm15 24H15a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H15a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H15a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/newspaper-4.js
// module id = 1302
// module chunks = 14